import styled from 'styled-components';

export const Container = styled.div``;

export const ContainerList = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    margin-top: 5px;
`;

export const List = styled.div`
    background-color: ${(props) => props.theme.color.grey0};
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 8px;
    padding: 8px 0;
    width: 100%;
    span {
        align-items: center;
        display: flex;
        justify-content: center;
        padding-left: 8px;
        font-size: 14px;
        color: ${(props) => props.theme.color.grey4};
    }
    a {
        padding-right: 8px;
    }
`;
export const Image = styled.img`
    width: 25px;
    height: 25px;
    margin-right: 5px;
`;

export const LabelField = styled.p`
    width: 100%;
    text-align: center;
    color: ${(props) => props.theme.color.grey4};
    i {
        padding-right: 4px;
    }
`;

export const CloseButton = styled.a`
    cursor: pointer;
    opacity: 50%;
    &:hover {
        opacity: 70%;
    }
`;

export const FileWrapper = styled.label<{ isLoading: boolean }>`
    display: flex;
    flex: 1;
    gap: 10px;
    flex-direction: row;
    align-items: center;
    opacity: ${(props) => (props.isLoading ? '.4' : '1')};
    background-color: ${(props) => props.theme.color.grey0};
    margin-top: 4px;
    border-radius: 4px;
    overflow: hidden;
`;

export const FileName = styled.label`
    display: flex;
    flex: 1;
`;

export const FileImage = styled.label`
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const FileRemove = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    width: 60px;
    opacity: 50%;
    &:hover {
        opacity: 70%;
    }
`;
